<template>
	<div>
		<div style="margin-top: 10px; width: 100%;">
			<center>
				<el-input v-model="keyword" :placeholder="this.$t('adminmanage.searchadminhint')"
					style="width: 400px; margin-right:10px; justify-content: center;"
					@keyup.enter.native="searchAdmin()"></el-input>
				<el-button icon="el-icon-search" @click="searchAdmin()" type="primary">{{$t('adminmanage.search')}}</el-button>
				<el-button style="margin-left: 30px;" icon="el-icon-plus" @click="openAddAdminForm()" type="success">
					{{$t('adminmanage.insertadmin')}}</el-button>
			</center>
		</div>

		<!-- 新增管理员框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form :model="admin">
				<el-form-item :label="this.$t('adminmanage.insertadmin_account')" :label-width="formLabelWidth">
					<el-input v-model="admin.username" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('adminmanage.insertadmin_pwd')" :label-width="formLabelWidth">
					<el-input v-model="admin.password" autocomplete="off" @input="change($event)">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancle()">{{$t('adminmanage.insertcancel')}}</el-button>
				<el-button type="primary" @click="addAdmin()">{{$t('adminmanage.insertbtn')}}</el-button>
			</div>
		</el-dialog>

		<div class="adminContainer">
			<el-card class="adminBox" v-for="(admin,index) in Admins" :key="index">
				<div slot="header" class="clearfix">
					<span>{{admin.username}}</span>
					<el-button style="float: right; padding: 3px 0; color: red;" @click="deleteOneAdmin(admin.id)"
						type="text" icon="el-icon-delete"></el-button>
				</div>
				<div>
					<div class="img-container"><img :src="admin.image" :alt="admin.username" class="imageclass"></div>
					<div style="adminInfo-container">
						<!-- <div class="adminInfoOne">
							管理员ID：{{admin.id}}
						</div> -->
						<div class="adminInfoOne">
							{{$t('adminmanage.name')}}{{admin.username}}
						</div>
						<div class="adminInfoOne">
							{{$t('adminmanage.createtime')}}{{admin.createTime}}
						</div>
						<div class="adminInfoOne">
							<el-switch @change="enabledChange(admin)" v-model="admin.enabled" active-text="Enable"
								inactive-text="Unable">
							</el-switch>
						</div>
						<div>
							{{$t('adminmanage.userrole')}}
							<el-tag style="margin-right: 2px;" type="warning" v-for="(item,indexj) in admin.roles"
								:key="indexj">{{item.roleName}}</el-tag>
							<el-popover @hide="updateAdminRole(admin)" placement="right" :title="$t('adminmanage.rolelist')" width="200"
								trigger="click">
								<el-select multiple v-model="selectedRoles" :placeholder="$t('adminmanage.select')">
									<el-option v-for="(role,indexk) in allRoles" :key="indexk" :label="role.roleName"
										:value="role.id">
									</el-option>
								</el-select>
								<el-button slot="reference" icon="el-icon-more" @click="getAllRoles(admin)" type="text">
								</el-button>
							</el-popover>
						</div>
					</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		components: {

		},
		data() {
			return {
				keyword: '',
				Admins: [{
						id: '',
						username: '',
						image: '',
						createTime: '',
						enabled: 1
					},
					{
						id: '',
						username: '',
						image: '',
						createTime: '',
						enabled: 1
					}
				],
				admin: {
					username: '',
					password: ''
				},
				allRoles: [],
				selectedRoles: [],
				dialogWidth: "30%",
				dialogTitle: this.$t('adminmanage.insertadmin_title'),
				dialogFormVisible: false,
				formLabelWidth: '120px'
			};
		},
		created() {
			this.reload();
		},
		methods: {
			reload() {
				let that = this;
				that.getRequest('/tpa-api/admin/getAllAdmin', null).then(
					resp => {
						if (resp) {
							that.Admins = resp.result;
						}
					});
			},
			enabledChange(admin) {
				let data = {
					adminId: admin.id,
					enabled: admin.enabled
				};
				this.postRequest('/tpa-api/admin/updateAdminEnabled', data).then(resp => {
					if (resp) {
						this.reload();
					}
				});
			},
			deleteOneAdmin(adminId) {
				// 跳出确认框
				let that = this;
				that.$confirm(this.$t('notification.adminmanagemessage'), this.$t('notification.title'), {
					confirmButtonText: this.$t('notification.confirm'),
					cancelButtonText: this.$t('notification.cancel'),
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/admin/deleteOneAdmin/' + adminId, null).then(resp => {
						if (resp.code == 200) {
							// 重新加载
							that.page = 1;
							that.length = 5;
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});
			},
			searchAdmin() {
				let user = JSON.parse(window.localStorage.getItem('user'))
				if (this.keyword == user.username){
					this.$message(this.$t('notification.adminmanagemessage1'));
					return;
				}
				this.getRequest('/tpa-api/admin/getAdmin?name=' + this.keyword, null).then(
					resp => {
						if (resp) {
							this.Admins = resp.result;
							if (resp.result.length == 0) {
								this.$message(this.$t('notification.adminmanagemessage1'));
							}
						}
					});
			},
			getAllRoles(admin) {
				this.getRequest('/tpa-api/admin/getAllRoles', null).then(
					resp => {
						if (resp) {
							this.allRoles = resp.result;
							this.selectedRoles = [];
							let roles = admin.roles;
							roles.forEach(r => {
								this.selectedRoles.push(r.id);
							});
						}
					});
			},
			updateAdminRole(admin) {
				let adminId = admin.id;
				// 获取到选中的角色
				let data = {
					adminId: adminId,
					roleIds: this.selectedRoles
				};
				this.postRequest('/tpa-api/admin/updateAdminRole', data).then(
					resp => {
						if (resp) {
							this.reload();
						}
					});

			},
			openAddAdminForm() {
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('adminmanage.insertadmin_title');
			},
			cancle() {
				this.dialogFormVisible = false;
			},
			addAdmin() {
				let username = this.admin.username;
				let password = this.admin.password;
				if (username == '' || password == '') {
					this.$message({
						message: this.$t('notification.cancelinfo'),
						type: 'warning'
					});
					return;
				}
				let data = {
					username: username,
					password: password
				}
				this.postRequest("/tpa-api/admin/createAdmin/", data).then(resp => {
					if (resp) {
						this.dialogFormVisible = false;
						this.reload();
					}
				});
				// 清空
				this.admin = {};
			}
		},
	};
</script>

<style>
	.imageclass {
		width: 72px;
		height: 72px;
		border-radius: 72px;
	}

	.adminInfo-container {
		margin-top: 20px;
	}

	.adminInfoOne {
		font-size: 16px;
		color: #204a7f;
	}

	.img-container {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.adminContainer {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}

	.adminBox {
		width: 350px;
		margin-bottom: 20px;
	}
</style>
